// eslint-disable-next-line import/prefer-default-export
export const getPromotionConfig = ({ promotions, hasEventStarted }) => {
    if (!promotions || !promotions.enabled) {
        return null;
    }

    if (hasEventStarted && promotions.inrunning.enabled) {
        return promotions.inrunning;
    }

    if (!hasEventStarted && promotions.prerace.enabled) {
        return promotions.prerace;
    }

    return null;
};
